import { Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import { ProfessionType } from '../../../../common/types';
import React from "react";
import ConfigInputContainer from '../../../../common/components/ConfigInputContainer';
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";

interface Props {
    onSetProfessions: (value: ProfessionType[]) => void;
    professionTypes: ProfessionType[];
    backToDetails: () => void;
    nextToPlay: () => void;
}

const InterviewGameConfig = ({ onSetProfessions, professionTypes , backToDetails, nextToPlay}: Props) => {

    const { t } = useTranslation();
    const realProfession = t('games.interview.settings.professionType.real');
    const unrealProfession = t('games.interview.settings.professionType.unreal');

    const options = [
        { label: realProfession, value: ProfessionType.REAL },
        { label: unrealProfession, value: ProfessionType.UNREAL },
    ];

    return (
      <ConfigScreen
        configTitlePath="games.interview.settings.title"
        nextToPlay={nextToPlay}
        nextActionDisabled={professionTypes.length === 0}
        backToDetails={backToDetails}
      >
        <ConfigInputContainer labelPath='games.interview.settings.professionType.type'>
          <Checkbox.Group
            options={options}
            onChange={(checkedValues: any)=>onSetProfessions(checkedValues)}
            value={professionTypes}/>
        </ConfigInputContainer>
      </ConfigScreen>
    )
};

export default InterviewGameConfig;
